const assemblagesImages = [
  {
    id: "assemblages-image-1",
    src: require("../assets/assemblages/IMG_3316_edited-3.jpg"),
    description: "Ink and tissue paper on paper, 594 x 841mm",
  },
  {
    id: "assemblages-image-2",
    src: require("../assets/assemblages/IMG_3270_edited.jpg"),
    description: "Oil on paper, 210 x 297mm",
  },
];

export default assemblagesImages;
